module.exports = __webpack_public_path__ + "img/score_left.beb8cf59.png";